import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Directory from './components/Directory';
import RechargeTips from './components/RechargeTips';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <Directory />
        <RechargeTips />
      </main>
      <Footer />
    </div>
  );
}